var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignUpSlient4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191.297,
    height: 220.096,
    viewBox: "0 0 191.297 220.096",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22761",
    "data-name": "Group 22761",
    transform: "translate(-79.921 -305.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12204",
    "data-name": "Path 12204",
    d: "M277.463,781.04c-52.685,0-95.388,4.154-95.388,9.279s42.7,9.278,95.388,9.278,95.384-4.152,95.384-9.278-42.706-9.279-95.384-9.279",
    transform: "translate(-101.629 -273.898)",
    fill: "#d6daf9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22760",
    "data-name": "Group 22760",
    transform: "translate(-1121.655 -98.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22716",
    "data-name": "Group 22716",
    transform: "translate(1201.576 470.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12259",
    "data-name": "Path 12259",
    d: "M1209.855,1235.133l-3.069-3.254-4.422.682a.616.616,0,0,1-.633-.9l2.147-3.924-2.013-3.991a.614.614,0,0,1,.662-.882l4.4.829,3.176-3.149a.614.614,0,0,1,1.041.356l.569,4.436,3.978,2.042a.618.618,0,0,1-.02,1.107l-4.04,1.913-.719,4.413A.615.615,0,0,1,1209.855,1235.133Z",
    transform: "translate(-1201.655 -1220.365)",
    fill: "#c4d1eb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22717",
    "data-name": "Group 22717",
    transform: "translate(1325.215 496.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12260",
    "data-name": "Path 12260",
    d: "M1752.794,1610.771l-4.441-.533-2.96,3.357a.615.615,0,0,1-1.062-.288l-.864-4.388-4.1-1.776a.615.615,0,0,1-.055-1.1l3.906-2.178.423-4.451a.614.614,0,0,1,1.028-.393l3.277,3.042,4.364-.977a.618.618,0,0,1,.693.862l-1.878,4.057,2.274,3.85A.615.615,0,0,1,1752.794,1610.771Z",
    transform: "translate(-1738.993 -1598.853)",
    fill: "#c4d1eb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22755",
    "data-name": "Group 22755",
    transform: "translate(1215.94 403.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22748",
    "data-name": "Group 22748",
    transform: "translate(13.906 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22721",
    "data-name": "Group 22721",
    transform: "translate(19.239 0.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12263",
    "data-name": "Path 12263",
    d: "M1528.768,451.578c-.239.32.632,1,.263,1.126-.1,2.644-6.432,6.12-7.581,4.948-1.6-1.628.5-10.38-2.5-11.319-6.078-1.9-10.48,7.837-13.109,6.751-5.352-2.2-10.019-13.662-2.061-19.939,3.876-4.749.019-20.2,8.658-23.064C1524.011,405.077,1533.676,445.146,1528.768,451.578Z",
    transform: "translate(-1499.524 -409.65)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22722",
    "data-name": "Group 22722",
    transform: "translate(23.735 67.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12264",
    "data-name": "Path 12264",
    d: "M1530.678,831.429a3.211,3.211,0,0,1-2.921.838A1.974,1.974,0,0,0,1530.678,831.429Z",
    transform: "translate(-1527.758 -831.429)",
    fill: "#f48661",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22723",
    "data-name": "Group 22723",
    transform: "translate(15.28 135.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12265",
    "data-name": "Path 12265",
    d: "M1482.125,1266.043c.165-1.172-.2-3.187-1.119-6.338,1.815,0,3.343-.8,5.2-.771.506,2.965,1.293,7.83,1.293,7.83l.084,3.849-12.924.1a30.139,30.139,0,0,0,3.92-2.352C1478.859,1268.18,1481.968,1267.174,1482.125,1266.043Z",
    transform: "translate(-1474.657 -1258.933)",
    fill: "#f9af79",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22724",
    "data-name": "Group 22724",
    transform: "translate(14.41 143.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12266",
    "data-name": "Path 12266",
    d: "M1483.048,1312.641h-13.337c-.494-.045-.615-.448-.443-.694.353-.512,2.955-1.738,4.7-2.551,3.067.321,8.461-.942,8.945-1.65C1483.756,1310.1,1483.324,1312.58,1483.048,1312.641Z",
    transform: "translate(-1469.194 -1307.746)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22725",
    "data-name": "Group 22725",
    transform: "translate(31.378 136.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12267",
    "data-name": "Path 12267",
    d: "M1583.224,1267.388a21.947,21.947,0,0,0,.035-6.544c1.817,0,3.545-.336,5.4-.31,0,3.05-.063,7.575-.063,7.575l.082,3.849-12.921.1a30.256,30.256,0,0,0,3.917-2.352C1579.957,1269.524,1583.068,1268.518,1583.224,1267.388Z",
    transform: "translate(-1575.757 -1260.532)",
    fill: "#f9af79",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22726",
    "data-name": "Group 22726",
    transform: "translate(30.507 143.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12268",
    "data-name": "Path 12268",
    d: "M1584.143,1312.641H1570.8c-.493-.045-.612-.448-.44-.694.349-.512,2.953-1.738,4.7-2.551,3.067.321,8.457-.942,8.941-1.65C1584.851,1310.1,1584.418,1312.58,1584.143,1312.641Z",
    transform: "translate(-1570.289 -1307.746)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22727",
    "data-name": "Group 22727",
    transform: "translate(0 7.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12269",
    "data-name": "Path 12269",
    d: "M1408.153,479.223l-4.862-5.124s-5.2,2.861-11.266,5.593c-1.669-2.9-4.389-12.449-4.536-12.9s3.185-6.191,2.442-6.334-1.714,3.06-2.5,2.734-2.813-7.76-3.29-7.355c-.886.759,1.069,4.626.6,4.908s-1.656-4.286-2.558-4.092,1.524,4.157,1.259,4.538-2.808-3.336-3.333-2.473c-.284.465,2.342,3.236,1.8,3.547s-2.907-1.436-3.189-.871,2.209,1.155,2.9,2.586,1.95,1.986,2.368,4.691,1.558,17.156,4.5,18.319C1391.067,488,1408.153,479.223,1408.153,479.223Z",
    transform: "translate(-1378.697 -455.82)",
    fill: "#f9af79",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22728",
    "data-name": "Group 22728",
    transform: "translate(14.945 58.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12270",
    "data-name": "Path 12270",
    d: "M1483.924,776.51l3.94,2.2,8.012,12.249-14.326,33.725s1.614,5.073,2.139,7.607c.549,2.651,1.9,25.4,1.9,25.4l-6.113.1s-5.806-24.225-6.789-32.086c-1.192-9.548,6.079-32.285,6.079-32.285,1.355-4.638,4.276-14.184,4.276-14.184S1483.754,776.916,1483.924,776.51Z",
    transform: "translate(-1472.554 -776.51)",
    fill: "#1c2a47",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22729",
    "data-name": "Group 22729",
    transform: "translate(26.315 54.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12271",
    "data-name": "Path 12271",
    d: "M1557.683,747.618a11.517,11.517,0,0,0,1.223,6.168c.992,2,2.711,3.577,3.94,6.028,2.327,4.648,3.589,11.244,2.718,15.485,0,0-4.809,18.366-4.62,25.077a86.435,86.435,0,0,0,1.462,9.95c.482,2.665.644,22.77.644,22.77l-6.827-.206L1551,800.461l-2.211-28.825-4.822-19.417Z",
    transform: "translate(-1543.964 -747.618)",
    fill: "#040227",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22730",
    "data-name": "Group 22730",
    transform: "translate(15.79 23.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12272",
    "data-name": "Path 12272",
    d: "M1486.214,566.923c-2.174,1.006-6.116,2.514-6.116,2.514l-2.238-7.087c12.668-7.208,11.671-6.042,21.178-5.9,7.6.109,10.783-1.343,17.322,16.316,0,0-4.978,2.237-6.763,2.955-.768-2.183-2.151-6.537-2.96-4.054a72.115,72.115,0,0,0-2.715,11.431c-.38,2.309-1.206,5.266-.774,7.618a70.562,70.562,0,0,1-9.122,1.24h-.035a31.047,31.047,0,0,1-5.605-.593s-.775-16.378-1.188-17.063a6.572,6.572,0,0,1-.75-6.859C1486.742,566.792,1486.665,566.717,1486.214,566.923Z",
    transform: "translate(-1477.86 -556.295)",
    fill: "#699dee",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22731",
    "data-name": "Group 22731",
    transform: "translate(28.598 40.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12273",
    "data-name": "Path 12273",
    d: "M1563.356,683.961c-.089.012-.492-.04-.823-.034a6.68,6.68,0,0,0-.856.077,2.294,2.294,0,0,0-.522-.312c-.144-.065-.374-.091-.533-.165s-.3-.216-.457-.284c-.4-.175-.774-.216-.9,0-.1.176,2.142,1.547,2.142,1.547,2.081.012,4.253,1.074,9.073-2.068,2.748-1.2,16.106-7.8,16.376-9.238.154-.81-1.9-7.055-3.573-11.8-1.29.578-4.038,1.8-5.575,2.443,1.411,2.988,3.074,6.949,2.9,7.433-.043.128-.212.356-9.242,6.268-.227.147-.462.3-.7.457q-.955.622-2.04,1.328l-2.573-.269s-4.079.281-4.2.746c-.053.213.287.319.7.382h.014l.184.021h.006c.45.053.922.063,1.036.1a2.738,2.738,0,0,1,.616.3c-2.545,1.04-2.348.669-3.191.616-.212-.016-.437.047-.639.032-.34-.032-.614-.234-.876-.251a1.151,1.151,0,0,0-.771.232c-.091.09.079.222.4.368a11.016,11.016,0,0,0,4.114.653c.349.084-.29.216-1.29.11a5.261,5.261,0,0,1-.9-.014c-.22-.05-.421-.19-.635-.243s-.4-.047-.572-.078c-.219-.041-.525-.211-.7-.228a1.679,1.679,0,0,0-1.043.1,17.162,17.162,0,0,0,2.811,1.272s2.043.293,2.5.293C1563.616,683.755,1563.891,683.88,1563.356,683.961Z",
    transform: "translate(-1558.301 -661.683)",
    fill: "#f9af79",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22732",
    "data-name": "Group 22732",
    transform: "translate(30.777 15.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12274",
    "data-name": "Path 12274",
    d: "M1577.244,507.651s.582,4.678.922,6.3c.355,1.7.892,7.053-2.63,7.921s-2.433-5.821-2.492-7.549-1.056-7.752-1.056-7.752Z",
    transform: "translate(-1571.987 -506.57)",
    fill: "#f9af79",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22733",
    "data-name": "Group 22733",
    transform: "translate(31.082 18.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12275",
    "data-name": "Path 12275",
    d: "M1579.349,522.5c-.035.022-.069.044-.106.066a4.408,4.408,0,0,1-4.912.071c-.229-1.5-.429-2.711-.429-2.711l5.257,1.081S1579.236,521.627,1579.349,522.5Z",
    transform: "translate(-1573.901 -519.922)",
    fill: "#f27458",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22734",
    "data-name": "Group 22734",
    transform: "translate(28.534 7.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12276",
    "data-name": "Path 12276",
    d: "M1563.753,450.715a6.022,6.022,0,0,1,3.527,2.254c1.41,1.9,2.656,7.689-1.42,10.675s-7.616-.671-7.9-4.427S1558.16,450.39,1563.753,450.715Z",
    transform: "translate(-1557.897 -450.7)",
    fill: "#f9af79",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22735",
    "data-name": "Group 22735",
    transform: "translate(29.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12277",
    "data-name": "Path 12277",
    d: "M1572.718,421.947c2.592-3.044,2.722-1.454,3.121-5.756.093-11.854-13.838-11.962-13.153-5.61-1.163,1.365-.193,2.012.816,2.881C1571.911,420.714,1572.081,411.983,1572.718,421.947Z",
    transform: "translate(-1562.156 -406.388)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22737",
    "data-name": "Group 22737",
    transform: "translate(29.198 1.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12279",
    "data-name": "Path 12279",
    d: "M1562.717,418.347q-.823.161-.6-.6a5.16,5.16,0,0,1,2.264-1.838A9.146,9.146,0,0,0,1562.717,418.347Z",
    transform: "translate(-1562.068 -415.907)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22738",
    "data-name": "Group 22738",
    transform: "translate(28.098 6.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12280",
    "data-name": "Path 12280",
    d: "M1555.331,457.974a15.543,15.543,0,0,1,.414-6.142c.614-3.044,2.776-1.7,1.8-.206C1555.641,454.534,1556.163,453.576,1555.331,457.974Z",
    transform: "translate(-1555.161 -450.003)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22739",
    "data-name": "Group 22739",
    transform: "translate(28.3 3.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12281",
    "data-name": "Path 12281",
    d: "M1559.487,432.769q1.143-.91.581-1.758a4.251,4.251,0,0,0-3.639.386A5.458,5.458,0,0,1,1559.487,432.769Z",
    transform: "translate(-1556.429 -430.776)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22740",
    "data-name": "Group 22740",
    transform: "translate(30.156 6.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12282",
    "data-name": "Path 12282",
    d: "M1569.325,449.743q-1.291.139-1.237,1.154a3.87,3.87,0,0,0,2.979,1.661A5.841,5.841,0,0,1,1569.325,449.743Z",
    transform: "translate(-1568.086 -449.743)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22741",
    "data-name": "Group 22741",
    transform: "translate(28.021 10.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12283",
    "data-name": "Path 12283",
    d: "M1554.676,471.133c-.039.812.308,1.492.777,1.515s.885-.614.924-1.429-.306-1.492-.775-1.515S1554.717,470.322,1554.676,471.133Z",
    transform: "translate(-1554.673 -469.704)",
    fill: "#f9af79",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22742",
    "data-name": "Group 22742",
    transform: "translate(38.674 11.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12284",
    "data-name": "Path 12284",
    d: "M1621.582,479.694c-.052.83.359,1.534.919,1.572s1.05-.6,1.1-1.438-.357-1.535-.916-1.573S1621.636,478.86,1621.582,479.694Z",
    transform: "translate(-1621.578 -478.254)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22754",
    "data-name": "Group 22754",
    transform: "translate(0 129.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22749",
    "data-name": "Group 22749"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12290",
    "data-name": "Path 12290",
    d: "M1408.542,1254.929a27.584,27.584,0,0,1-2.423-2.413q-21.275-23.453-34.115-25.985c-2.277-.449-5.408-.216-7.786-.216h-37.462c-1.413,0-2.046-.271-3.125.706q-1.676,1.518,1.12,3.881,6.932,5.536,20.977,5.646,2.5.06,3.908.1c.933.026,1.783-.161,2.23.853a2.182,2.182,0,0,1,.169.694l-23.864-.216q-4.345-.081-9.6-4.659-20.459-16.833-25.921-13.885-2.656,1.405.193,4.068,21.543,26.531,41.782,29.9a22.093,22.093,0,0,0,6.255.24q35.34-2.81,37.351,2.183l13.027,16.357Z",
    transform: "translate(-1291.364 -1218.997)",
    fill: "#f9af79",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22750",
    "data-name": "Group 22750",
    transform: "translate(98.283 40.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12291",
    "data-name": "Path 12291",
    d: "M1923.246,1519.619q-7.143-9.549-14.638-19.7c6.373-7.083,15.979-14.608,30.407-24.81,2.589,2.174,5.838,5.015,9.4,8.242C1952.274,1500.119,1941.55,1511.662,1923.246,1519.619Z",
    transform: "translate(-1908.608 -1475.111)",
    fill: "#699dee",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22751",
    "data-name": "Group 22751",
    transform: "translate(94.801 34.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12292",
    "data-name": "Path 12292",
    d: "M1919.338,1445.154a88.456,88.456,0,0,0-9.482-6.762q-18.539,12.748-23.115,22.091,2.341,3.7,4.765,7.18C1897.658,1461.192,1906.542,1454.243,1919.338,1445.154Z",
    transform: "translate(-1886.741 -1438.392)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22752",
    "data-name": "Group 22752",
    transform: "translate(98.283 58.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12293",
    "data-name": "Path 12293",
    d: "M1915.521,1588.3a193.218,193.218,0,0,1,19.771,19.919,70.339,70.339,0,0,1-12.045,6.567q-7.143-9.549-14.638-19.7.621-.689,1.283-1.386C1911.558,1591.946,1913.427,1590.157,1915.521,1588.3Z",
    transform: "translate(-1908.608 -1588.299)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22753",
    "data-name": "Group 22753",
    transform: "translate(94.801 52.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12294",
    "data-name": "Path 12294",
    d: "M1897.135,1556.647c-2.094,1.858-3.963,3.647-5.63,5.4q-2.423-3.478-4.765-7.18.326-.665.722-1.348a29.15,29.15,0,0,1,1.921-2.868A97.9,97.9,0,0,1,1897.135,1556.647Z",
    transform: "translate(-1886.741 -1550.653)",
    fill: "#c4d1eb",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22759",
    "data-name": "Group 22759",
    transform: "translate(1301.329 410.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12297",
    "data-name": "Path 12297",
    d: "M2171.9,1480.608l-3.829-1.346-3.282,2.391a.559.559,0,0,1-.886-.464l.1-4.057-3.285-2.381a.557.557,0,0,1,.167-.986l3.889-1.162,1.251-3.859a.557.557,0,0,1,.988-.145l2.3,3.339,4.058-.007a.559.559,0,0,1,.444.9l-2.461,3.225,1.257,3.857A.558.558,0,0,1,2171.9,1480.608Z",
    transform: "translate(-2160.485 -1468.358)",
    fill: "#c4d1eb",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpSlient4);
export default __webpack_public_path__ + "static/media/sign-up-slient4.0bc0162aed25ec2ce96e05fed45af119.svg";
export { ForwardRef as ReactComponent };